'use client';

import { Link } from '@coolblue-development/freddy';
import selectItemOfProductsInWishlistTrigger from '@coolblue-development/ga4-events/triggers/Wishlist/selectItemOfProductsInWishlistTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { PromotionalProductImage } from '@coolblue-development/next-patterns/core';
import { PromoIcon, PromotionalContent } from '@features/product/typings';
import legacyPromotionalContentFactory from '@features/shared/PromotionalContent/legacyPromotionalContentFactory';
import { promotionalContentFactory } from '@features/shared/PromotionalContent/promotionalContentFactory';
import { ReactElement } from 'react';

type Props = {
  productId: number;
  index: number;
  totalIndices: number;
  href?: string;
  imageId: string;
  alt: string;
  promoIcon?: PromoIcon;
  primaryLabel?: ReactElement;
  name: string;
  promotionalContent?: PromotionalContent;
  shouldShowPromoLabelPlaceholder: boolean;
};

export default function TrackedProductImage({
  productId,
  index,
  totalIndices,
  href,
  imageId,
  alt,
  promoIcon,
  primaryLabel,
  name,
  promotionalContent,
  shouldShowPromoLabelPlaceholder
}: Props) {
  const { trackEvent } = useAnalytics();
  const legacyPromotionalContent = legacyPromotionalContentFactory(promoIcon, name);

  const handleTracking = () => {
    trackEvent(
      selectItemOfProductsInWishlistTrigger({
        index: index,
        total_indices: totalIndices,
        method: 'image',
        item_id: productId
      })
    );
  };

  return (
    <Link href={href} onClick={handleTracking}>
      <PromotionalProductImage
        imageId={imageId}
        alt={alt}
        size='small'
        labelsPosition={{ xs: 'belowImage', lg: 'middle' }}
        primaryLabel={primaryLabel}
        showPromoLabelPlaceholder={shouldShowPromoLabelPlaceholder}
        promotionalContent={
          promotionalContent
            ? promotionalContentFactory(promotionalContent)
            : legacyPromotionalContent
        }
      />
    </Link>
  );
}
